<div class="flxClmn bs-enabled">
    <div class="page-title-container flxRow-between">
        <div class="flxClmn-center f-1-0">
            <div class="page-title-inner-container flxRow">
                <span class="page-title">Archive Discovery</span>
                <more-info-c></more-info-c>
            </div>
            <div class="page-subtitle-container">
                <span class="page-subtitle">
                    Every inbound and outbound email that passed through Trustifi's relay — search, view and act
                </span>
            </div>
        </div>

    </div>

    <div class="page-inner-content-holder no-scroll flxClmn gap-2">
        <!--query-->
        <ng-template #queryEl>
            <div class="flxRow" (clickOutside)="showQueryModal = false;" style="align-items: center; position: relative; width: fit-content;">
                <div class="flxRow" style="flex: 1 0; border: solid 1px var(--ui-border-strong); border-radius: var(--ui-radius-sm); overflow: visible; position: relative; min-width: 560px; height: 32px; border-top-right-radius: 0; border-bottom-right-radius: 0;">
                    <div class="flxRow hSpace05" style="align-items: center; padding: 10px; border-right: solid 1px var(--ui-border-strong); cursor: pointer; border-radius: var(--ui-radius-sm) 0 0 var(--ui-radius-sm);"
                         (click)="showQueryModal = !showQueryModal"
                         [ngStyle]="{'background' : showQueryModal ? '#f7f7f7' : 'white'}">
                        <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 22px; height: 22px; vertical-align: middle; fill: currentColor; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M881.4 250.9H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h739.9c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM272.1 454H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5S296 454 272.1 454zM272.1 657.1H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM853.8 847.5L715.3 709c-16.9-16.9-16.9-44.6 0-61.5s44.6-16.9 61.5 0L915.3 786c16.9 16.9 16.9 44.6 0 61.5s-44.6 16.9-61.5 0zM467.9 860.2H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h326.4c23.9 0 43.5 19.6 43.5 43.5 0.1 23.9-19.5 43.5-43.5 43.5z"/><path d="M619.4 290.5C493.3 290.5 391 392.8 391 519s102.3 228.5 228.5 228.5S847.9 645.2 847.9 519 745.6 290.5 619.4 290.5z m0 388.4c-88.3 0-159.9-71.6-159.9-159.9 0-88.3 71.6-159.9 159.9-159.9s160 71.5 160 159.9c0 88.3-71.6 159.9-160 159.9z"/></svg>
                        <i class="far fa-chevron-down" style="font-size: smaller;"></i>
                    </div>

                    <div class="flxRow hSpace1 hvr-shadow" style="flex: 1 0; align-items: center; padding: 0 10px; cursor: pointer;"
                         (click)="showQueryModal = !showQueryModal">
                        <a class="diamond-indent animated fadeIn" style="font-weight: bold; height: auto; position: relative; padding-left: 12px; text-transform: capitalize;"
                           *ngFor="let query of emailQueryDisplay;"
                           title="{{query.tooltip}}">
                            {{query.title}}
                        </a>
                    </div>

                    <!--query modal-->
                    <div style="z-index: 2000; position: absolute; bottom: -3px; transform: translateY(100%); line-height: 15px; left: 0; background: white; border: solid 1px var(--ui-border); border-radius: var(--ui-radius-md); box-shadow: var(--ui-shadow-lg); min-width: 580px;"
                         *ngIf="showQueryModal">
                        <div class="flxClmn vSpace1" style="padding: 15px; padding-right: 30px;">
                            <div class="flxRow-between" style="align-items: center; height: 30px; z-index: 150; margin: 0;">
                                <span style="font-weight: bold; font-size: 14px">Search Query</span>
                                <app-dropdown-c style="width: 220px;" class="animated fadeIn"
                                                *ngIf="savedCases?.length"
                                                text="{{selectedCase?.name || 'Select case'}}"
                                                [enableSearch]="true"
                                                itemDisplayKey="name"
                                                [items]="savedCases"
                                                (onItemClicked)="selectQueryTemplate($event.item)"
                                                (onItemDelete)="deleteCase($event.item)"
                                                (click)="$event.stopPropagation();">
                                </app-dropdown-c>
                            </div>
                            <hr class="w100" style="opacity: 0.5;"/>
                            <div class="flxRow hSpace2">
                                <label class="radio-container" style="display: block; width: fit-content; height: 30px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
                                    <input type="radio" name="normalQuery" [value]="queryTypes.normal"
                                           [(ngModel)]="queryType"
                                           [checked]="queryType === queryTypes.normal">
                                    <span class="checkmark"></span>
                                </label>
                                <div class="flxClmn vSpace2" style="padding-left: 15px; flex: 1 0;"
                                     [ngStyle]="queryType === queryTypes.messageIdOnly ? {'opacity' : '0.5', 'cursor' : 'pointer'} : {'opacity' : '1' , 'cursor' : 'default'}"
                                     (click)="queryType = queryTypes.normal">
                                    <div class="flxRow hSpace2">
                                        <span style="font-weight: bold; flex-basis: 130px; margin-top: 5px;">Date:</span>
                                        <div class="flxClmn" style="margin-left: 0; flex: 1 0;">
                                            <app-dropdown-c class="capitalize-box" style="height: 27px; min-height: 27px; flex: 1 0;"
                                                            [ngStyle]="{'margin-bottom' : resultsPeriod === dic.CONSTANTS.trendsPeriod.range ? '10px' : '0'}"
                                                            text="{{resultsPeriod.display}}">
                                                <li *ngFor="let periodObj of casesPeriods;"
                                                    (click)="changePeriod(periodObj)">
                                                    {{periodObj.display}}
                                                </li>
                                            </app-dropdown-c>

                                            <div class="flxRow hSpace1" style="align-items: center;" *ngIf="resultsPeriod === dic.CONSTANTS.trendsPeriod.range">
                                                <div class="flxRow hSpace05 f-1-0" style="align-items: center;">
                                                    <span>Date Range:</span>
                                                    <date-picker-c class="f-1-0" style="max-width: 220px;"
                                                                   [(dateModel)]="range"
                                                                   [isRange]="true"
                                                                   [dateFormat]="'mm/dd/yyyy'">
                                                    </date-picker-c>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--CC: taken from archive-search.component.html -> conditions logic (AND/OR) dropdown-->
                                    <div class="flxRow hSpace3" style="align-items: center;">
                                        <span style="font-weight: bold; flex-basis: 130px;">Conditions logic:</span>
                                        <app-dropdown-c class="f-1-0 m-0"
                                                        [text]="dic.CONSTANTS.archiveCaseConditionsOperator[emailQuery.conditionsOperator]?.display || dic.CONSTANTS.archiveCaseConditionsOperator.and.display">
                                            <ul>
                                                <li *ngFor="let operatorObj of dic.CONSTANTS.archiveCaseConditionsOperator | keyvalue: gs.returnZero"
                                                    (click)="emailQuery.conditionsOperator = operatorObj.value.value">
                                                    {{ operatorObj.value.display }}
                                                </li>
                                            </ul>
                                        </app-dropdown-c>
                                    </div>
                                    <span *ngIf="emailQuery.conditionsOperator === dic.CONSTANTS.archiveCaseConditionsOperator.or.value"
                                          class="animated fadeIn" style="font-size: 12px; color: #486db5;">
                                        Emails will be included if they match at least one of: From / Recipients / Subject / Contains the words.
                                        The date, attachments, size, compliance and "Negative" conditions will still apply to all results.
                                    </span>

                                    <div class="flxRow hSpace3" style="align-items: center; position: relative;">
                                        <span *ngIf="!emailQuery.fromNegate" style="font-weight: bold; flex-basis: 130px;">From:</span>
                                        <span *ngIf="emailQuery.fromNegate" style="font-weight: bold; flex-basis: 130px;">From is <b style="color: var(--bs-danger)">NOT</b>:</span>
                                        <input type="text" style="margin: 0; flex: 1 0; height: 27px;"
                                               (keyup.enter)="applyQuery();"
                                               placeholder="Email, domain or partial address (e.g. john)"
                                               [(ngModel)]="emailQuery.from">
                                        <div class="flxRow-end bs-enabled">
                                            <checkbox class="text-danger" style="font-size: 11px;"
                                                      tooltip="Make this field negative"
                                                      [(model)]="emailQuery.fromNegate">Negative</checkbox>
                                        </div>
                                    </div>

                                    <div class="flxRow hSpace3" style="align-items: center; position: relative;">
                                        <span *ngIf="!emailQuery.rcptToNegate" style="font-weight: bold; flex-basis: 130px;">Recipients:</span>
                                        <span *ngIf="emailQuery.rcptToNegate" style="font-weight: bold; flex-basis: 130px;">Recipients are <b style="color: var(--bs-danger)">NOT</b>:</span>
                                        <input type="text" style="margin: 0; flex: 1 0; height: 27px;"
                                               (keyup.enter)="applyQuery();"
                                               placeholder="Email/Domain  separated by commas"
                                               [(ngModel)]="emailQuery.rcptTo">
                                        <div class="flxRow-end bs-enabled">
                                            <checkbox class="text-danger" style="font-size: 11px;"
                                                      tooltip="Make this field negative"
                                                      [(model)]="emailQuery.rcptToNegate">Negative</checkbox>
                                        </div>
                                    </div>


                                    <div class="flxRow hSpace3" style="align-items: center; position: relative;">
                                        <span *ngIf="!emailQuery.subjectNegate" style="font-weight: bold; flex-basis: 130px;">Subject:</span>
                                        <span *ngIf="emailQuery.subjectNegate" style="font-weight: bold; flex-basis: 130px;">Subject is <b style="color: var(--bs-danger)">NOT</b>:</span>
                                        <input type="text" style="margin: 0; flex: 1 0; height: 27px;"
                                               (keyup.enter)="applyQuery();"
                                               placeholder="Email's subject (exact or partial)"
                                               [(ngModel)]="emailQuery.subject">
                                        <div class="flxRow-end bs-enabled">
                                            <checkbox class="text-danger" style="font-size: 11px;"
                                                      tooltip="Make this field negative"
                                                      [(model)]="emailQuery.subjectNegate">Negative</checkbox>
                                        </div>
                                    </div>

                                    <div class="flxRow hSpace3" style="align-items: center; position: relative;">
                                        <span *ngIf="!emailQuery.textNegate" style="font-weight: bold; flex-basis: 130px;">Contains the words:</span>
                                        <span *ngIf="emailQuery.textNegate" style="font-weight: bold; flex-basis: 130px;">Does <b style="color: var(--bs-danger)">NOT</b> contain the words:</span>
                                        <input type="text" style="margin: 0; flex: 1 0; height: 27px;"
                                               (keyup.enter)="applyQuery();"
                                               placeholder="Email's content (exact or partial)"
                                               [(ngModel)]="emailQuery.text">
                                        <div class="flxRow-end bs-enabled">
                                            <checkbox class="text-danger" style="font-size: 11px;"
                                                      tooltip="Make this field negative"
                                                      [(model)]="emailQuery.textNegate">Negative</checkbox>
                                        </div>
                                    </div>

                                    <div class="flxRow hSpace3" style="align-items: center; position: relative;">
                                        <span style="font-weight: bold; flex-basis: 130px;">Compliance:</span>
                                        <app-dropdown-c id="compliance" style="margin: 0; flex: 1 0; height: 27px;"
                                                        [items]="compliances"
                                                        [isMultipleSelection]="true"
                                                        itemDisplayKey="name"></app-dropdown-c>
                                        <i style="font-weight: 400; margin-left: 0.5rem;" class="far fa-question-circle"
                                           tooltip="Will apply only to outbound emails that were sent with Trustifi and scanned for sensitive content">
                                        </i>
                                    </div>

                                    <div class="flxRow hSpace2" style="align-items: center; position: relative;">
                                        <checkbox id="hasAttachments" [(model)]="emailQuery.hasAttachments">
                                            Has attached files
                                        </checkbox>
                                        <!--CC: taken from archive-cases.component.html -> caseAttachmentNameInput-->
                                        <input type="text" style="margin: 0; flex: 1 0; height: 27px;"
                                               (keyup.enter)="applyQuery();"
                                               placeholder="Attachment name (optional)"
                                               [disabled]="!emailQuery.hasAttachments"
                                               [(ngModel)]="emailQuery.attachmentName">
                                    </div>

                                    <div class="flxRow hSpace3" style="align-items: center; position: relative;">
                                        <span style="font-weight: bold; flex-basis: 130px;">Size:</span>
										<input type="number" min="0" style="margin: 0; flex: 1 0; width: 0; min-width: 150px; height: 27px;"
											   (keyup.enter)="applyQuery();"
											   placeholder="Min (MB)"
											   [(ngModel)]="emailQuery.sizeMin">
										<span>-</span>
										<input type="number" min="0" style="margin: 0; flex: 1 0; width: 0; min-width: 150px; height: 27px;"
											   (keyup.enter)="applyQuery();"
											   placeholder="Max (MB)"
											   [(ngModel)]="emailQuery.sizeMax">
									</div>
                                </div>
                            </div>

                            <div class="flxRow hSpace2 mt-2" style="align-items: flex-start;">
                                <label class="radio-container" style="display: block; width: fit-content; height: 30px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
                                    <input type="radio" name="byIdQuery" [value]="queryTypes.messageIdOnly"
                                           [(ngModel)]="queryType"
                                           [checked]="queryType === queryTypes.messageIdOnly">
                                    <span class="checkmark"></span>
                                </label>
                                <div class="flxRow hSpace3" style="align-items: center; padding-left: 15px; flex: 1 0; position: relative;"
                                     [ngStyle]="queryType === queryTypes.normal ? {'opacity' : '0.5', 'cursor' : 'pointer'} : {'opacity' : '1' , 'cursor' : 'default'}"
                                     (click)="queryType = queryTypes.messageIdOnly">
                                    <span style="font-weight: bold; flex-basis: 130px;">Message ID:</span>
                                    <input type="text" style="margin: 0; flex: 1 0; height: 27px;"
                                           (keyup.enter)="applyQuery();"
                                           placeholder="Exact message ID"
                                           [(ngModel)]="emailQuery.message_id">
                                </div>
                            </div>

                            <hr class="w100" style="opacity: 0.5;"/>
                            <div class="flxRow-between w100 hSpace2" style="align-items: center;">
                                <!--CC: taken from table-query-templates-controls.html -> save-as-template controls (backed by archive cases)-->
                                <div class="flex-column gap-2 align-items-start f-1-0" (click)="$event.stopPropagation()">
                                    <a class="blue-link flex-row gap-1 align-items-center animated fadeIn"
                                       *ngIf="!saveAsCaseInput"
                                       (click)="saveAsCaseInput = {name: selectedCase?.name || ''}">
                                        <i class="far fa-check" style="opacity: 0;"></i>
                                        <i class="far fa-cog"></i>
                                        <span>Save as case</span>
                                    </a>
                                    <div class="flex-row align-items-center gap-1 animated fadeIn"
                                         *ngIf="saveAsCaseInput">
                                        <input type="text" class="f-1-0" style="min-width: 0;"
                                               (keyup.enter)="saveAsCase();"
                                               placeholder="Case name"
                                               [(ngModel)]="saveAsCaseInput.name">
                                        <btn-c style="min-width: 30px;"
                                               endIcon="zmdi zmdi-check"
                                               [loading]="caseActionInProcess"
                                               (action)="saveAsCase();">
                                        </btn-c>
                                        <btn-c style="min-width: 30px;"
                                               endIcon="zmdi zmdi-close" color="danger"
                                               variant="text"
                                               [isDisabled]="caseActionInProcess"
                                               (action)="saveAsCaseInput = null;">
                                        </btn-c>
                                    </div>
                                </div>
                                <div class="flxRow" style="gap: 8px;">
                                    <btn-c variant="text" style="height: 32px;"
                                           btnTooltip="Reset all query fields" (action)="resetQuery();">
                                        Reset
                                    </btn-c>
                                    <btn-c style="height: 32px;"
                                           [loading]="getEmailsInProcess"
                                           (action)="applyQuery();">
                                        Search
                                    </btn-c>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <btn-c class="connected-to-left" style="align-self: flex-end; height: 32px; margin-left: -2px;"
                       [loading]="{flag: getEmailsInProcess}"
                       (action)="applyQuery();">
                    Search
                </btn-c>

                <!--abort loading label-->
                <span class="flxClmn-center animated fadeIn" style="cursor: pointer; padding: 0 6px 5px; font-weight: 300; color: #85000d; font-size: 0.75rem; margin-left: 10px;"
                      *ngIf="getEmailsInProcess"
                      (click)="abortLoadingEmails()">
                    <b>Abort</b>
                </span>
            </div>
        </ng-template>

        <!--shared preview content, projected either inline (list view) or into a modal (table view)-->
        <ng-template #emailPreviewContent>
            <loader *ngIf="previewEmailInProcess" height="100" width="100" class="align-self-center" style="opacity: 0.8;"></loader>

            <!--tabs-->
            <div class="simple-tab-row w100 flxRow" *ngIf="archiveService.currentMessage?.content?.parsedContent">
                <div class="tab-header"
                     [ngClass]="{'chosen' : archiveService.tab === dic.CONSTANTS.archiveEmailViewPages.content}"
                     (click)="archiveService.tab = dic.CONSTANTS.archiveEmailViewPages.content">
                    <span class="hvr-opacity">Email Content</span>
                </div>
                <div class="tab-header" style="overflow: auto;"
                     [ngClass]="{'chosen' : archiveService.tab === dic.CONSTANTS.archiveEmailViewPages.headers}"
                     (click)="archiveService.tab = dic.CONSTANTS.archiveEmailViewPages.headers">
                    <span class="hvr-opacity">Headers</span>
                </div>
                <div class="tab-header"
                     *ngIf="archiveService.currentMessage._source.emailId"
                     [ngClass]="{'chosen' : archiveService.tab === dic.CONSTANTS.archiveEmailViewPages.tracking}"
                     (click)="archiveService.tab = dic.CONSTANTS.archiveEmailViewPages.tracking">
                    <span class="hvr-opacity">Outbound Tracking</span>
                </div>
                <div class="tab-header"
                     *ngIf="archiveService.currentMessage._source.quarantineIds && archiveService.currentMessage._source.quarantineIds.length"
                     [ngClass]="{'chosen' : archiveService.tab === dic.CONSTANTS.archiveEmailViewPages.quarantined}"
                     (click)="archiveService.tab = dic.CONSTANTS.archiveEmailViewPages.quarantined">
                    <span class="hvr-opacity">Inbound Analysis</span>
                </div>
            </div>

            <div class="flxClmn" style="flex: 1 0; overflow: auto;" *ngIf="archiveService.currentMessage?.content?.parsedContent">
                <archive-email-details-component *ngIf="archiveService.tab === dic.CONSTANTS.archiveEmailViewPages.content"
                                                 [archiveConfig]=archiveConfig
                                                 class="flxClmn f-1-0" style="overflow: auto;" ></archive-email-details-component>
                <archive-email-headers-component *ngIf="archiveService.tab === dic.CONSTANTS.archiveEmailViewPages.headers"
                                                 class="flxClmn" style="flex: 1 0; overflow: auto;"></archive-email-headers-component>
                <archive-email-tracking-component *ngIf="archiveService.tab === dic.CONSTANTS.archiveEmailViewPages.tracking"
                                                  class="flxClmn" style="flex: 1 0; overflow: auto;"></archive-email-tracking-component>
                <archive-email-quarantined-component *ngIf="archiveService.tab === dic.CONSTANTS.archiveEmailViewPages.quarantined"
                                                     class="flxClmn" style="flex: 1 0; overflow: auto;"></archive-email-quarantined-component>
            </div>
        </ng-template>

        <!--query + view toggle-->
        <div class="flxRow-between" style="align-items: center; flex-wrap: wrap; gap: 8px;">
            <ng-container [ngTemplateOutlet]="queryEl"></ng-container>

            <!--CC: taken from outbound-rule-usage.component.html -> btn-c period-buttons-group toggle-->
            <div class="period-buttons-group flxRow hSpace1">
                <btn-c startIcon="far fa-list"
                       variant="{{viewMode !== viewTypes.list ? 'outlined' : ''}}"
                       (action)="changeViewType(viewTypes.list);">
                    List
                </btn-c>
                <btn-c startIcon="far fa-table"
                       variant="{{viewMode !== viewTypes.table ? 'outlined' : ''}}"
                       (action)="changeViewType(viewTypes.table);">
                    Table
                </btn-c>
            </div>
        </div>

        <!--list view (default) - classic split-pane: results list + inline email preview-->
        <div class="flxRow" style="flex: 1 0; overflow: hidden;" *ngIf="viewMode === viewTypes.list">
            <div class="flxClmn" style="flex: 1 0; padding: 5px; min-width: 450px; background: linear-gradient(#163f5d1a, transparent, #a0a0a02e) , linear-gradient(74deg, #d3f1ff6b , transparent 51%, transparent);"
                 [ngClass]="getEmailsInProcess && !hasSearched && 'shinyFX'">

                <!--placeholder-->
                <div class="flxClmn" style="position: relative; flex: 1 0; overflow: auto;" *ngIf="!hasSearched">
                    <span style=" position: absolute; z-index: 10; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.4; font-weight: bold;">{{getEmailsInProcess ? 'Loading emails list' : 'Set your filters and search the archive'}}</span>
                    <div class="flxClmn fading-overlay" style="flex: 1 0; padding: 5px; background: white; overflow: auto;">
                        <div class="flxClmn" style="overflow: hidden; background:#f7f7f7; align-items: center; flex: 1 0;">
                            <div class="flxRow hSpace1 w100" style="height: 75px; min-height:75px; padding: 10px; opacity: 0.6; "
                                 [ngStyle]="!$last && {'border-bottom': 'solid 1px #e3e4e4'}"
                                 *ngFor="let placeholder of [1,2,3,4,5,6,7,8,9,10]">
                                <div class="flxClmn-center" style="align-items: center;">
                                    <div style="height: 15px; width: 15px; border-radius: 50%; background: #c4c4c4; opacity: 0.15;"></div>
                                </div>
                                <div class="flxClmn-between" style="flex: 3 0;">
                                    <div style="height:15px; max-width: 50%;  background: #c4c4c4; border-radius: 50px; opacity: 0.15;"></div>
                                    <div style="height: 20px; max-width: 73%; background: #c4c4c4; border-radius: 50px; opacity: 0.2;"></div>
                                </div>
                                <div class="flxClmn-between" style="flex: 1 0; padding: 3px 0;">
                                    <div style="height:15px; background: #c4c4c4; border-radius: 50px; opacity: 0.15;"></div>
                                    <div class="flxRow-between">
                                        <div style="height:15px; width: 25%;  background: #c4c4c4; border-radius: 50px; opacity: 0.15;"></div>
                                        <div style="height:15px; width: 25%; background: #c4c4c4; border-radius: 50px; opacity: 0.15;"></div>
                                        <div style="height:15px; width: 25%; background: #c4c4c4; border-radius: 50px; opacity: 0.15;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Email list-->
                <div class="flxClmn" style="flex: 1 0; overflow: auto;" *ngIf="hasSearched">
                    <div class="w100 flxRow animated fadeIn" style="background: #677184; padding: calc(3px + 0.4vw); align-items: center; z-index: 1; min-height: 60px;">
                        <div class="flxRow-between hSpace2 w100" style="position: relative; align-items: center;">
                            <!--search results input and label-->
                            <div class="flxRow-start hSpace1" style="align-items: center; flex: 1 0; max-width: 350px;">
                                <div style="width: 20px; min-width: 20px; margin-left: -4px;">
                                    <checkbox style="display: block;"
                                              [(model)]="selectedAll"
                                              (modelChange)="toggleAllEmails()"
                                              (click)="$event.stopPropagation()">
                                    </checkbox>
                                </div>
                                <search-box [(model)]="searchArchiveEmailTxt"
                                            (modelChange)="searchEmailInResults(searchArchiveEmailTxt)"
                                            [isDisabled]="!archiveService.currentEmailsList.length"
                                            placeholder="Find in results"
                                            style="width:100%;">
                                </search-box>
                                <span style="color: white; flex-shrink: 0; align-self: center;" *ngIf="!getEmailsInProcess && !selectedEmails.length && archiveService.currentFilteredEmailsList.length">
                                    {{archiveService.currentFilteredEmailsList.length}} email{{archiveService.currentFilteredEmailsList.length > 1 ? 's' : ''}}
                                </span>
                                <div class="loading-spinner" style="position: relative; top: 0; left: 0; border: 2px solid transparent; border-top-color: white !important; border-left-color: white !important; opacity: 1; height: 15px; width: 15px;"
                                     *ngIf="archiveService.currentEmailsList.length && getEmailsInProcess"></div>
                            </div>

                            <!--action for results-->
                            <div class="flxRow hSpace1"  style="color: white;">
                                <div class="flxRow hSpace1" *ngIf="selectedEmails.length">
                                    <div class="flxClmn fadeIn vSpace05" style="align-items: center; cursor: pointer;" *ngIf="archiveConfig?.allow_delete"
                                         tooltip="Delete emails"
                                         (click)="deleteMultipleEmails(selectedEmails)">
                                        <i class="far fa-trash-alt" style="font-size: 1.2rem;"></i>
                                    </div>

                                    <div class="flxClmn fadeIn vSpace05" style="align-items: center; cursor: pointer;"
                                         tooltip="Download EMLs"
                                         (click)="downloadMultipleEmls(selectedEmails)">
                                        <i class="far fa-save" style="font-size: 1.2rem;"></i>
                                    </div>

                                    <!--CC: bulk restore - mirrors single restore in archive-email-details.component.html-->
                                    <div class="flxClmn fadeIn vSpace05" style="align-items: center; cursor: pointer;"
                                         tooltip="Restore emails"
                                         (click)="restoreMultipleEmails(selectedEmails)">
                                        <i class="far fa-recycle" style="font-size: 1.2rem;"></i>
                                    </div>
                                </div>

                                <div class="flxClmn fadeIn vSpace05" style="align-items: center; cursor: pointer;"
                                     *ngIf="archiveService.currentFilteredEmailsList.length"
                                     tooltip="Export to CSV"
                                     (click)="exportResultsToCsv()">
                                    <i class="far fa-file-export" style="font-size: 1.2rem;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--results table-->
                    <div class="animated fadeIn flxClmn" style="flex: 1 0; overflow: auto; background: white;"
                         *ngIf="archiveService.currentEmailsList?.length || getEmailsInProcess">
                        <virtual-scroller class="f-1-0" style="border: solid 1px #cccccc;"
                                          #archiveEmailsListScroll
                                          [items]="archiveService.currentFilteredEmailsList"
                                          [ngClass]="{'is-loading-or-empty' : !archiveService.currentFilteredEmailsList.length}">
                            <table class="w100 mailsListTable ellips">
                                <tbody #container>
                                <tr *ngFor="let email of archiveEmailsListScroll.viewPortItems"
                                    (click)="getArchiveEmailInfo(email)"
                                    [ngClass]="{'selected': email.selected, 'is-active': email.show}">

                                    <td style="width: 23px; padding: 5px; padding-right: 0;">
                                        <checkbox style="display: block;"
                                                  [(model)]="email.selected"
                                                  (modelChange)="checkSelectAllEmails()"
                                                  (click)="$event.stopPropagation()">
                                        </checkbox>
                                    </td>
                                    <td>
                                        <div class="flxClmn vSpace1">
                                            <div class="flxRow-between">
                                                <div>
                                                    <span style="opacity: 0.85;">{{email._source.from}}</span>
                                                </div>
                                                <span *ngIf="email._source.deleted" style="color: red; padding: 0 5px; flex-shrink: 0; opacity: 1; font-size: 0.7rem; font-family: 'Roboto Condensed', sans-serif;">[Deleted]</span>
                                            </div>

                                            <div style="font-weight: 500; font-size: 0.95rem;">
                                                <span >{{email._source.subject}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width: 150px;">
                                        <div class="flxClmn-between vSpace05" style="align-items: flex-end;">
                                            <div style="flex: 1 0;">
                                                <span>{{ email._source.created | date:'MM/dd/yyyy HH:mm' }}</span>
                                            </div>
                                            <div class="flxRow-between hSpace05 w100" style="flex:1 0; align-items: baseline;">
                                                <span style="visibility: hidden;"></span>
                                                <div style=" color: darkslategrey;" *ngIf="email._source.attachments.length">
                                                    <span style="font-weight: 400;" >{{email._source.attachments.length}}</span>
                                                    <i class="far fa-paperclip" style=" font-size: 14px; -webkit-text-stroke: 0.3px #f7f6f9;"></i>
                                                </div>
                                                <span style="opacity: 0.5; font-size: 0.6rem;" >{{(email._source.size | FormatBytes: 2)}}</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </virtual-scroller>
                        <div *ngIf="!archiveService.currentFilteredEmailsList.length" class="flxClmn-center"
                             style="align-items: center; flex: 1 0; background: white;">
                            <div class="loading-spinner" style="position: relative; top: 0; left: 0; opacity: 0.7;" *ngIf="getEmailsInProcess"></div>
                            <span *ngIf="!getEmailsInProcess && archiveService.currentEmailsList.length" style="color: darkgrey; font-size: 18px;">No results for this search</span>
                        </div>
                    </div>
                    <!--placeholder for empty results-->
                    <div class="f-1-0 flxClmn centralize" style="background: white;" *ngIf="!getEmailsInProcess && !archiveService.currentEmailsList.length">
                        <span style="color: darkgrey; font-size: 18px;">No emails found for this search</span>
                    </div>
                </div>
            </div>

            <!--Email display area (inline pane)-->
            <div class="vertical-separator" style="border-color: #e3e4e4; border-left: none;"></div>
            <div class="flxClmn" style="flex: 2 0; align-items: center; background: #f7f7f7; margin-left: 20px; position: relative; overflow: auto;"
                 [ngStyle]="archiveService.currentMessage?.content?.parsedContent && hasSearched && {'background':' transparent'} ">
                <div class="flxClmn-center vSpace2 w100" style="flex:1 0; overflow: auto; position: relative;"
                     *ngIf="archiveService.currentMessage?.show">
                    <ng-container [ngTemplateOutlet]="emailPreviewContent"></ng-container>
                </div>

                <div *ngIf="!archiveService.currentMessage?.show" class="flxClmn-center"
                     style="align-items: center; flex: 1 0;">
                    <i class="far hvr-opacity fa-envelope-open-text" style="font-size: 4vw;  opacity: 0.1;"></i>
                </div>
            </div>
        </div>

        <!--table view - modern sortable table + preview modal-->
        <div class="flxClmn" style="flex: 1 0; overflow: hidden;" *ngIf="viewMode === viewTypes.table">
            <trustifi-table-c
                class="trustifi-table" style="flex: 1 0; z-index: 5;"
                [list]="archiveService.currentEmailsList"
                [headers]="[
                    {text: 'Date', sortKey: '_source.created', width: '150px'},
                    {text: 'From', sortKey: '_source.from'},
                    {text: 'Subject', sortKey: '_source.subject'},
                    {text: 'Recipients'},
                    {text: 'Attachments', sortKey: '_source.attachments.length', width: '110px', centered: true},
                    {text: 'Size', sortKey: '_source.size', width: '90px'},
                    {text: '', width: '90px'},
                ]"
                [cellsPrototype]="[
                    {textKey: '_source.created', textType: 'dateAndTime'},
                    {html: 'fromCell'},
                    {textKey: '_source.subject', placeHolder: '(No subject)'},
                    {html: 'recipientsCell'},
                    {html: 'attachmentsCell'},
                    {html: 'sizeCell'},
                    {html: 'viewEmailCell'},
                ]"
                [bulkActions]="{
                    enable: true,
                    selectBulkActionCb: selectMultipleEmailsAction,
                    initBulkActionsFunction: showBulkActions,
                    showInRed: {enable: true, terms: ['Delete']}
                }"
                [cellActions]="{
                    enable: true,
                    selectItemActionCb: selectAction,
                    initActionsFunction: showEmailActions,
                    showInRed: {enable: true, terms: ['Delete']}
                }"
                (searchFunction)="searchEmailInResults($event.searchTerm)"
                [options]="{
                    exportToCsvFunction: exportResultsToCsv,
                    loadingTableFlag: getEmailsInProcess && !archiveService.currentEmailsList.length,
                    itemsNameSingular: 'email',
                    itemUniqueIdentifier: '_id',
                    defaultSortKey: '-_source.created',
                    emptyStateMessage: 'Set your filters above and click <b>Search</b> to query the archive'
                }"
            >
                <ng-template #customCells let-item let-cellId="cellId">
                    <div *ngIf="cellId === 'fromCell'" class="flxRow hSpace1" style="align-items: center;">
                        <span class="ellipsis" [tooltip]="item._source.from">{{item._source.from}}</span>
                        <span *ngIf="item._source.deleted" style="color: red; flex-shrink: 0; font-size: 0.7rem; font-family: 'Roboto Condensed', sans-serif;">[Deleted]</span>
                    </div>

                    <span *ngIf="cellId === 'recipientsCell'" class="ellipsis" [tooltip]="item._source.rcptTo?.join(', ')">
                        {{item._source.rcptTo?.join(', ')}}
                    </span>

                    <div *ngIf="cellId === 'attachmentsCell'" class="flxRow-center hSpace05" style="align-items: center;">
                        <ng-container *ngIf="item._source.attachments?.length">
                            <span>{{item._source.attachments.length}}</span>
                            <i class="far fa-paperclip"></i>
                        </ng-container>
                    </div>

                    <span *ngIf="cellId === 'sizeCell'">{{item._source.size | FormatBytes: 2}}</span>

                    <a *ngIf="cellId === 'viewEmailCell'" class="blue-link text-decoration-underline"
                       (click)="getArchiveEmailInfo(item); $event.stopPropagation();">
                        View Email
                    </a>
                </ng-template>
            </trustifi-table-c>
        </div>
    </div>

    <!--Email display area (modal, table view only)-->
    <popup-c *ngIf="viewMode === viewTypes.table && archiveService.currentMessage?.show"
             head="Email Preview" size="large"
             (closeCb)="archiveService.setCurrentEmail(null);">
        <div class="flxClmn-center vSpace2 w100" style="flex:1 0; overflow: auto; position: relative; min-height: 200px;">
            <ng-container [ngTemplateOutlet]="emailPreviewContent"></ng-container>
        </div>
    </popup-c>


</div>
